import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { CognitoAuthService } from '@auth/services/cognito-auth.service';
import { RdrAuthService } from '@app/auth/services/rdr-auth.service';
import { MyMonthlyStatsService } from '@app/pages/insights/services/my-monthly-stats.service';
import { FeatureToggleService, RdrFeature } from '@app/ui/services/feature-toggle.service';
import { RdrToastService } from '@app/ui/services/rdr-toast.service';
import { Observable, concatMap, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MonthlyStatsPageGuard {
  constructor(
    private router: Router,
    private cognitoAuthService: CognitoAuthService,
    private rdrAuthService: RdrAuthService,
    private featureToggleService: FeatureToggleService,
    private myMonthlyStatsService: MyMonthlyStatsService,
    private toastService: RdrToastService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.cognitoAuthService.hasCognitoSession().pipe(
      concatMap(() => this.rdrAuthService.getUser()),
      concatMap(() => {
        if (!this.featureToggleService.isFeatureEnabled(RdrFeature.monthly_stats)) {
          return of(true);
        }

        return this.myMonthlyStatsService.getAccess().pipe(
          map((access) => {
            if (access.canView) {
              return true;
            }

            this.toastService.info({
              message: 'This page has restricted access',
              config: { closeButton: true },
            });

            return this.router.parseUrl('/');
          }),
        );
      }),
    );
  }
}
